import script from "./contact.vue?vue&type=script&setup=true&lang=ts"
export * from "./contact.vue?vue&type=script&setup=true&lang=ts"

import "./contact.vue?vue&type=style&index=0&id=e7fcafb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7fcafb8"]])

export default __exports__